import React, {useEffect, useState, useMemo} from 'react';
import PropTypes from 'prop-types';
import {Icon} from '@/components/atoms';
import JsonFormsWrapper from '@/components/common/jsonForms/jsonFormsWrapper/JsonFormsWrapper';
import {mediaCardJsonSchema} from '@/services/schema/mediaCardJsonSchema';
import {getSalesTargetsDownloadMedia} from '@/services/salesTargets';
import {logger} from '@/helpers/logger';
const MediaCardForm = ({
  imageUri,
  handleDelete,
  mediaCardFormData,
  handleChange,
  MediaCardUiSchema,
  label = ''
}) => {
  const [imageSrc, setImageSrc] = useState();

  useEffect(() => {
    if (imageUri?.includes('http')) {
      setImageSrc(imageUri);
      return;
    }
    const fetchImage = async () => {
      try {
        const response = await getSalesTargetsDownloadMedia(
          'filePath=' + imageUri
        );
        const url = URL.createObjectURL(response);
        setImageSrc(url);
      } catch (error) {
        logger.error('Download error:', error);
      }
    };
    fetchImage();
    // cleanup objectUrl
    return () => {
      if (imageSrc?.startsWith('blob:')) {
        URL.revokeObjectURL(imageSrc);
      }
    };
    // eslint-disable-next-line
  }, [imageUri])

  const memoizedLabel = useMemo(() => {
    return label.length > 0 ? (
      <div
        data-testid='label-container'
        className='mb-4 flex items-center gap-2'>
        <div className='text-sm text-[#EFEFEF]'>{label}</div>
        <span
          className='material-icons-outlined text-sm text-white'
          aria-label='Information'>
          info
        </span>
      </div>
    ) : null;
  }, [label]);

  return (
    <div className='w-full max-w-[700px]'>
      <div className='media-card p-4'>
        {memoizedLabel}
        <div className='grid grid-cols-2 items-center gap-4'>
          <div className='file-upload'>
            {imageSrc ? (
              <img src={imageSrc} alt='Media' />
            ) : (
              <div className='flex items-center justify-center'>
                <Icon icon='loading' className='animate-spin text-white' />
              </div>
            )}
          </div>
          <div className='file-details'>
            <div className='flex items-end justify-end'>
              <Icon
                icon='delete'
                size='medium'
                onClick={handleDelete}
                className='close cursor-pointer text-right'
              />
            </div>
            <JsonFormsWrapper
              jsonschema={mediaCardJsonSchema}
              uischema={MediaCardUiSchema}
              data={mediaCardFormData}
              onChange={handleChange}
              // Updating form data on change
            />
          </div>
        </div>
      </div>
    </div>
  );
};

MediaCardForm.propTypes = {
  imageUri: PropTypes.string.isRequired,
  handleDelete: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  mediaCardFormData: PropTypes.shape({
    title: PropTypes.string,
    imageId: PropTypes.string,
    optIn: PropTypes.bool
  }).isRequired,
  MediaCardUiSchema: PropTypes.object.isRequired,
  label: PropTypes.string
};

export default React.memo(MediaCardForm);
